/* import __COLOCATED_TEMPLATE__ from './flexible-transfer-modal.hbs'; */
var _dec, _dec2, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { FlexibleTransferRequest, FlexibleTransferResponse } from '@square/dashboard-protos/models/squareup/bbfrontend/common/flexible_transfer/flexible_transfer_request_response';
import { TransferStep, TransferClientCapableFlow } from '@square/dashboard-protos/models/squareup/bbfrontend/common/flexible_transfer/flexible_transfer_step';
import { feature } from '@square/ember-features/macros';
import { LogEvent } from '@square/dashboard-protos/models/squareup/bbfrontend/common/workflow/ui_elements/common';
import { ButtonDescription } from '@square/dashboard-protos/models/squareup/bbfrontend/common/component/component';
import { GlyphIcon } from '@square/dashboard-protos/models/squareup/bbfrontend/common/glyph/glyph_icon';
// eslint-disable-next-line dashboard/use-utilities-window
import theWindow from 'ember-window-mock';
import { getSkippedStepIds, mapBannerVariantToBannerV2Type, setSkippedStepIds } from '@banking/ui/utils/flexible-transfers-utils';
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}
let FlexibleTransferModal = (_dec = service('bbfrontend/v1/flexible-transfer'), _dec2 = feature('banking/can_see_transfer_outage_banner_on_transfer_modal'), _class = class FlexibleTransferModal extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "flexibleTransferService", _descriptor, this);
    _initializerDefineProperty(this, "logEvents", _descriptor2, this);
    _initializerDefineProperty(this, "intl", _descriptor3, this);
    _initializerDefineProperty(this, "userRailsPermissions", _descriptor4, this);
    _initializerDefineProperty(this, "canSeeTransferOutageBannerOnTransferModal", _descriptor5, this);
    _initializerDefineProperty(this, "isPageLoading", _descriptor6, this);
    _initializerDefineProperty(this, "isButtonLoading", _descriptor7, this);
    _initializerDefineProperty(this, "steps", _descriptor8, this);
    _initializerDefineProperty(this, "context", _descriptor9, this);
    _initializerDefineProperty(this, "editedTransferAmount", _descriptor10, this);
    _initializerDefineProperty(this, "submissionError", _descriptor11, this);
    _initializerDefineProperty(this, "networkError", _descriptor12, this);
  }
  get previousSteps() {
    return this.steps?.slice(0, -1);
  }

  /**
   * Despite this being called "last" step, it's really
   * the step that's currently rendered.
   */
  get lastStep() {
    return this.steps?.slice(-1)[0];
  }
  get lastStepType() {
    if (!this.lastStep) {
      return;
    }
    if (hasOwnProperty(this.lastStep, 'transfersPrimer')) {
      return 'transfers_primer_step';
    }
    if (hasOwnProperty(this.lastStep, 'transferOptions')) {
      return 'transfer_options_step';
    }
    if (hasOwnProperty(this.lastStep, 'transferAmount')) {
      return 'transfer_amount_step';
    }
    if (hasOwnProperty(this.lastStep, 'transferConfirmation')) {
      return 'transfer_confirmation_step';
    }
    if (hasOwnProperty(this.lastStep, 'transferResult')) {
      return 'transfer_result_step';
    }
    return 'transfer_result_step';
  }
  get lastContext() {
    return this.context?.at(-1);
  }
  get allPreviousStepsSkipped() {
    const skippedStepIds = new Set(getSkippedStepIds());
    const previousStepIds = (this.previousSteps ?? []).map(step => step.identifier);
    return previousStepIds.every(id => skippedStepIds.has(id));
  }
  get showNavigation() {
    return this.lastStepType !== 'transfer_result_step' || this.lastStep?.transferResult?.allowsBackwardNavigation;
  }
  get showBackButton() {
    // If we show the user the primer step, and they click "Don't show again",
    // we should show the "X" button on the next step instead of the back arrow.
    if (this.allPreviousStepsSkipped) {
      return false;
    }
    return this.steps.length > 1;
  }
  get messageUnits() {
    if (this.lastStep?.bannerConfiguration) {
      const lastMessageUnit = this.lastStep.bannerConfiguration;
      const messageUnits = [{
        bannerV2Format: {
          title: lastMessageUnit.bannerDescription?.title,
          body: lastMessageUnit.bannerDescription?.text,
          type: mapBannerVariantToBannerV2Type(lastMessageUnit.bannerDescription?.variant),
          // if buttons is empty, primaryLinkText will be null
          primaryLinkText: lastMessageUnit.buttons?.[0]?.label || null,
          primaryLinkWebUrl: lastMessageUnit.buttons?.[0]?.web?.urlString || null,
          primaryClickLogEvent: lastMessageUnit.buttons?.[0]?.clickLogEvent || null,
          primaryViewLogEvent: lastMessageUnit.viewLogEvent || null
        }
      }];
      return messageUnits;
    }
    return undefined;
  }
  get showTransferOutageBanner() {
    return this.lastStep?.bannerConfiguration && this.canSeeTransferOutageBannerOnTransferModal;
  }
  get skippedStepIds() {
    return getSkippedStepIds() ?? [];
  }
  setLoading() {
    switch (this.lastStepType) {
      case 'transfer_amount_step':
      case 'transfer_confirmation_step':
      case 'transfer_result_step':
        this.isButtonLoading = true;
        break;
      case 'transfers_primer_step':
      case 'transfer_options_step':
      default:
        this.isPageLoading = true;
    }
  }
  async requestNextStep(args) {
    this.setLoading();
    const {
      stepSubmissionData
    } = args;
    try {
      const response = await this.flexibleTransferService.client.flexibleTransfer({
        variant: this.args.variant,
        clientCapableSteps: [FlexibleTransferRequest.ClientCapableStep.TRANSFERS_PRIMER, FlexibleTransferRequest.ClientCapableStep.TRANSFER_OPTIONS, FlexibleTransferRequest.ClientCapableStep.TRANSFER_AMOUNT,
        // TODO: https://block.atlassian.net/browse/BANKWEB-1747, remove this later after we move our transfer confirmation to sectioned
        FlexibleTransferRequest.ClientCapableStep.TRANSFER_CONFIRMATION, FlexibleTransferRequest.ClientCapableStep.TRANSFER_RESULT, FlexibleTransferRequest.ClientCapableStep.TRANSFER_OPTIONS_WITH_FOOTER_TEXT_LINK, FlexibleTransferRequest.ClientCapableStep.TRANSFER_AMOUNT_WITH_SECONDARY_HEADER, FlexibleTransferRequest.ClientCapableStep.TRANSFER_RESULT_WITH_RICH_TEXT_DESCRIPTION, FlexibleTransferRequest.ClientCapableStep.TRANSFER_OPTIONS_WITH_INLINE_STATUS, FlexibleTransferRequest.ClientCapableStep.TRANSFER_CONFIRMATION_SECTIONED_WITH_ROW_INFO_BOX],
        stepIdsToSkip: this.skippedStepIds,
        clientCapableFlows: [TransferClientCapableFlow.LINK_BANK_ACCOUNT, TransferClientCapableFlow.LINK_DEBIT_CARD, TransferClientCapableFlow.TRANSFER_SETTINGS],
        clientCapableActions: [FlexibleTransferRequest.ClientCapableAction.FINISH_AND_REFRESH],
        bannerCapability: {
          bannerClientCapableSteps: [FlexibleTransferRequest.ClientCapableStep.TRANSFER_OPTIONS, FlexibleTransferRequest.ClientCapableStep.TRANSFER_CONFIRMATION],
          bannerCapableActionTypes: [FlexibleTransferRequest.FlexibleTransferBannerCapability.FlexibleTransferBannerActionType.FLEXIBLE_TRANSFER_BANNER_ACTION_TYPE_WEB]
        },
        unitToken: this.args?.unitToken,
        accountId: this.args?.accountId,
        accountName: this.args?.accountName,
        context: this.lastContext,
        stepSubmissionData
      });
      this.handleReceivedStep(response);
    } catch (error) {
      // If user aborted step-up auth (closed TwoFactor modal), close gracefully
      if (error?.message?.includes('AUTHZ_ENGINES_ABORTED')) {
        this.args.onCloseModal?.({
          shouldRefresh: false
        });
        return;
      }
      // If we can't reach bb-frontend, create an error Transfer
      // Result screen and display it.

      // 1. shows the error if first or confirmation screen
      // 2. only shows the toast otherwise
      if (!this.lastStepType || this.lastStepType === 'transfer_confirmation_step') {
        const errorResponse = FlexibleTransferResponse.create({
          context: new Uint8Array(),
          step: TransferStep.create({
            identifier: 'transfer_result_step',
            viewLogEvent: LogEvent.create({
              applet: 'Banking',
              feature: 'Transfer Money',
              page: 'Error',
              action: LogEvent.Action.VIEW
            }),
            transferResult: TransferStep.TransferResult.create({
              icon: GlyphIcon.EXCLAMATION_TRIANGLE,
              iconStyle: TransferStep.TransferResult.IconStyle.WARNING,
              header: this.intl.t('banking.flexibleTransfers.error.header'),
              description: this.intl.t('banking.flexibleTransfers.error.description'),
              buttons: [TransferStep.Button.create({
                identifier: 'transfer_confirmation_button',
                buttonDescription: ButtonDescription.create({
                  text: this.intl.t('banking.flexibleTransfers.error.buttonLabel'),
                  style: ButtonDescription.ButtonStyle.BUTTON_STYLE_PRIMARY,
                  variant: ButtonDescription.ButtonVariant.BUTTON_VARIANT_NORMAL
                }),
                action: TransferStep.Action.create({
                  navigation: TransferStep.Action.Navigation.FINISH
                })
              })],
              allowsBackwardNavigation: false
            })
          })
        });
        this.steps = [...this.steps, errorResponse.step];
        this.context = [...this.context, errorResponse.context];
      } else {
        this.networkError = this.intl.t('banking.flexibleTransfers.error.networkError');
      }
    } finally {
      this.isPageLoading = false;
      this.isButtonLoading = false;
    }
  }
  handleReceivedStep(response) {
    const {
      clientFlow,
      context,
      step,
      submissionError
    } = response;
    if (submissionError) {
      this.submissionError = submissionError;
    } else if (clientFlow) {
      this.handleClientFlowAction(clientFlow);
    }
    // If the step identifier is the same, we need to stay on the same step.
    // Therefore, replace the last step in this.steps with the new response.
    else if (step && step?.identifier === this.lastStep?.identifier) {
      this.steps = [...this.steps.slice(0, -1), step];
      this.context = [...this.context.slice(0, -1), context];
    } else if (step) {
      this.steps = [...this.steps, step];
      this.context = [...this.context, context];
      if (this.lastStep?.viewLogEvent) {
        this.logEvents.track(this.lastStep.viewLogEvent, this.lastStep.viewLogEvent?.dynamicProperties);
      }
      // track CDP if the step has a viewLogEvent coming back from bannerConfiguration
      if (this.lastStep?.bannerConfiguration?.viewLogEvent) {
        this.logEvents.track(this.lastStep.bannerConfiguration.viewLogEvent, this.lastStep.bannerConfiguration.viewLogEvent.dynamicProperties);
      }
    }
  }

  // Callback used by child screens to determine next step in the flow
  updateStep(selectedElement, value) {
    this.submissionError = '';
    this.networkError = '';
    if (selectedElement.action?.clickLogEvent) {
      this.logEvents.track(selectedElement.action.clickLogEvent, selectedElement.action.clickLogEvent?.dynamicProperties);
    }
    if (this.lastStep?.transferAmount && value) {
      this.handleTransferAmountStep(value);
      return;
    }
    if (this.lastStep?.transfersPrimer && selectedElement?.action?.step && value) {
      this.handleTransfersPrimerStep(selectedElement?.action?.step, value);
      return;
    }
    if (selectedElement.action?.navigation) {
      this.handleNavigationAction(selectedElement);
      return;
    }
    if (selectedElement?.action?.step) {
      this.handleStepAction(selectedElement.action.step);
    }
    if (selectedElement.action?.clientFlow) {
      this.handleClientFlowAction(selectedElement.action.clientFlow);
    }
    if (selectedElement.action?.web) {
      this.handleWebAction(selectedElement.action.web);
    }
  }
  handleWebAction(web) {
    const urlString = web.urlString;
    theWindow.location.href = urlString;
  }
  handleClientFlowAction(clientFlow) {
    this.onClose({
      shouldRefresh: false,
      nativeFlow: TransferClientCapableFlow[clientFlow]
    });
  }
  handleTransferAmountStep(value) {
    this.editedTransferAmount = value.amount;
    this.requestNextStep({
      stepSubmissionData: {
        stepIdentifier: this.lastStep?.identifier,
        amount: {
          amount: value.amount,
          calculatedFee: value.calculatedFee
        }
      }
    });
  }
  handleTransfersPrimerStep(nextStep, value) {
    if (value.doNotShowAgainClicked) {
      const stepIdentifier = this.lastStep?.identifier;
      setSkippedStepIds([...getSkippedStepIds(), stepIdentifier]);
    }
    this.handleStepAction(nextStep);
  }
  handleNavigationAction(selectedElement) {
    const navigation = selectedElement.action?.navigation;
    if (navigation === TransferStep.Action.Navigation.FINISH || navigation === TransferStep.Action.Navigation.FINISH_AND_REFRESH) {
      this.onClose({
        shouldRefresh: navigation === TransferStep.Action.Navigation.FINISH_AND_REFRESH
      });
      return;
    }
    this.requestNextStep({
      stepSubmissionData: {
        stepIdentifier: this.lastStep?.identifier,
        selectedIdentifier: selectedElement.identifier
      }
    });
  }
  handleStepAction(step) {
    this.steps = [...this.steps, step];
    // Nested steps don't come with a new context, so we make a copy of the
    // last context in the stack to keep steps and context stacks equal.
    this.context = [...this.context, this.lastContext];
  }
  onClose(args) {
    // Clear out all steps; we want to start fresh after user closes the modal.
    this.steps = [];
    this.context = [];
    this.editedTransferAmount = undefined;
    this.submissionError = '';
    this.networkError = '';
    this.args.onCloseModal(args);
  }
  onBackOrClose() {
    this.steps = [...this.steps.slice(0, -1)];
    this.context = [...this.context.slice(0, -1)];
    this.submissionError = '';
    this.networkError = '';
    if (this.lastStepType !== 'transfer_amount_step') {
      this.editedTransferAmount = undefined;
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "flexibleTransferService", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "logEvents", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "userRailsPermissions", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "canSeeTransferOutageBannerOnTransferModal", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "isPageLoading", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "isButtonLoading", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "steps", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "context", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "editedTransferAmount", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "submissionError", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "networkError", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "requestNextStep", [action], Object.getOwnPropertyDescriptor(_class.prototype, "requestNextStep"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateStep", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateStep"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onClose", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onClose"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onBackOrClose", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onBackOrClose"), _class.prototype), _class);
export { FlexibleTransferModal as default };